import { useGetClient } from '../../common/utils/withTokenClient';
import { DomainDetailValidation } from '../../common/types/DomainDetailTypes';

export const useDomainDetailApi = (
  id: string
): {
  data: DomainDetailValidation | null;
  error: string;
  isLoading: boolean;
  fetch: () => void;
} => useGetClient(`domains/${id}/detail`);
